{
  "name": "crew-cvv-ui",
  "version": "6.1.2-RELEASE",
  "scripts": {
    "ng": "ng",
    "local": "ng serve --port 8080 --proxy-config proxy.conf.json",
    "start": "node server.js",
    "build": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "serve": "ng build && node server.js",
    "serve-prod": "ng build --configuration production && node server.js",
    "test": "ng test --code-coverage --watch=false --browsers ChromeHeadlessNoSandbox",
    "sonar": "sonar-scanner",
    "sonartest": "npm run test & npm run sonar"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.14",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.14",
    "@angular/compiler": "^19.2.14",
    "@angular/core": "^19.2.14",
    "@angular/forms": "^19.2.14",
    "@angular/localize": "^19.2.14",
    "@angular/material": "^19.2.19",
    "@angular/platform-browser": "^19.2.14",
    "@angular/platform-browser-dynamic": "^19.2.14",
    "@angular/router": "^19.2.14",
    "@angular/service-worker": "^19.2.14",
    "@azure/msal-angular": "^4.0.0",
    "@azure/msal-browser": "^4.0.0",
    "@fortawesome/angular-fontawesome": "^0.10.1",
    "@fortawesome/fontawesome-common-types": "^0.3.0",
    "@fortawesome/fontawesome-svg-core": "^1.3.0",
    "@fortawesome/free-regular-svg-icons": "^6.0.0",
    "@fortawesome/free-solid-svg-icons": "^6.0.0",
    "@ng-bootstrap/ng-bootstrap": "^18.0.0",
    "@ng-idle/core": "^16.0.0",
    "@ng-idle/keepalive": "^16.0.0",
    "@popperjs/core": "^2.11.8",
    "bootstrap": "^5.2.2",
    "deep-object-diff": "^1.1.0",
    "express": "^4.18.2",
    "express-actuator": "^1.8.4",
    "jquery": "^3.6.1",
    "leaflet": "^1.7.1",
    "leaflet-bing-layer": "^3.3.1",
    "leaflet-drift-marker": "^2.0.0",
    "leaflet-easybutton": "^2.4.0",
    "luxon": "^3.7.2",
    "material-icons": "^1.2.1",
    "moment": "^2.29.4",
    "morgan": "^1.10.0",
    "ng-packagr": "^19.2.2",
    "ngx-material-timepicker": "^13.1.1",
    "rxjs": "~7.8.1",
    "tailwindcss": "^2.2.19",
    "tslib": "^2.3.1",
    "uuid": "^8.3.2",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "^19.2.14",
    "@types/jasmine": "~3.6.0",
    "@types/leaflet": "^1.7.5",
    "@types/luxon": "^3.7.1",
    "@types/node": "^18.19.69",
    "@typescript-eslint/eslint-plugin": "^4.31.2",
    "@typescript-eslint/parser": "^4.31.2",
    "angular-in-memory-web-api": "^0.19.0",
    "eslint": "^7.32.0",
    "jasmine-core": "^3.10.1",
    "karma": "^6.3.3",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.0.3",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "karma-mocha-reporter": "^2.2.5",
    "karma-sonarqube-unit-reporter": "0.0.23",
    "karma-spec-reporter": "0.0.32",
    "puppeteer": "^24.0.0",
    "sonar-scanner": "^3.1.0",
    "typescript": "~5.5.4"
  },
  "overrides": {
    "node-forge": "1.4.0",
    "elliptic": "6.6.1",
    "picomatch": "4.0.4",
    "rollup": "4.60.1",
    "serialize-javascript": "7.0.5",
    "tar": "7.5.13",
    "vite": "6.4.2",
    "webpack": "5.106.1"
  }
}
